import { render, staticRenderFns } from "./panelLeft.vue?vue&type=template&id=0701b10e&scoped=true&"
import script from "./panelLeft.vue?vue&type=script&lang=js&"
export * from "./panelLeft.vue?vue&type=script&lang=js&"
import style0 from "./panelLeft.vue?vue&type=style&index=0&id=0701b10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0701b10e",
  null
  
)

export default component.exports